import { MENU_ADDONS } from "../menus"

const PACKAGE_ADDONS = MENU_ADDONS


const STANDARD = [
  PACKAGE_ADDONS.ADDON_BRANCH_PAGE_LAYER,
  PACKAGE_ADDONS.ADDON_HOME,
  PACKAGE_ADDONS.ADDON_FORM_RETRIEVE,
  PACKAGE_ADDONS.ADDON_RETROSPECTIVE_ORDER,
  PACKAGE_ADDONS.ADDON_RETROSPECTIVE_EDIT,
  PACKAGE_ADDONS.ADDON_ADVANCE,
  PACKAGE_ADDONS.ADDON_IMAGE_TYPE,
  PACKAGE_ADDONS.ADDON_EXTRA,
  PACKAGE_ADDONS.ADDON_WAREHOUSES,
  PACKAGE_ADDONS.ADDON_DEFAULT_PRODUCT,
  PACKAGE_ADDONS.ADDON_PRODUCTS,
  PACKAGE_ADDONS.ADDON_TREATMENT_TEMPLATE_TYPE,
  PACKAGE_ADDONS.ADDON_TREATMENT_TEMPLATE,
]

const PREMIUM = [
  ...STANDARD,
  PACKAGE_ADDONS.ADDON_EXTRA,
  PACKAGE_ADDONS.ADDON_REGISTER_APP,
  PACKAGE_ADDONS.ADDON_LINE_NOTIFY,
  PACKAGE_ADDONS.ADDON_EMAIL_NOTICE,
  PACKAGE_ADDONS.ADDON_DOCTOR_NOTE,
  PACKAGE_ADDONS.ADDON_SALARY,
  PACKAGE_ADDONS.ADDON_TREATMENT_PLAN_MANAGE,
  PACKAGE_ADDONS.ADDON_TREATMENT_PLAN_TYPE,
  PACKAGE_ADDONS.ADDON_TREATMENT_PLAN,
  PACKAGE_ADDONS.ADDON_TREATMENT_COURSE_MANAGE,
  PACKAGE_ADDONS.ADDON_TREATMENT_COURSE_TYPE,
  PACKAGE_ADDONS.ADDON_TREATMENT_COURSE,
  PACKAGE_ADDONS.ADDON_INCOME_EXPENSES,
  PACKAGE_ADDONS.ADDON_DOCTOR_NOTE_TYPE_FORM,
  PACKAGE_ADDONS.ADDON_DOCTOR_NOTE_FORM,
  PACKAGE_ADDONS.ADDON_DOCTOR_NOTE_TYPE_PIC,
  PACKAGE_ADDONS.ADDON_DOCTOR_NOTE_PIC,
  PACKAGE_ADDONS.ADDON_RECALL,
  PACKAGE_ADDONS.ADDON_RECALL_LIST,
  PACKAGE_ADDONS.ADDON_LAB,
  PACKAGE_ADDONS.ADDON_LAB_MANAGEMENT,
  PACKAGE_ADDONS.ADDON_LAB_LIST,
  PACKAGE_ADDONS.ADDON_LAB_TYPE,
  PACKAGE_ADDONS.ADDON_LAB_GROUP,
  PACKAGE_ADDONS.ADDON_LAB_COMPANY,
  PACKAGE_ADDONS.ADDON_X_RAY,
  PACKAGE_ADDONS.ADDON_XRAY_FILM_TYPE,
]

const ULTRA = [
  ...PREMIUM,
  PACKAGE_ADDONS.ADDON_APPLICATION_NOTICE,
  PACKAGE_ADDONS.ADDON_DASHBOARD,
  PACKAGE_ADDONS.ADDON_BANNER,
  PACKAGE_ADDONS.ADDON_ABOUT_US,
  PACKAGE_ADDONS.ADDON_SERVICE,
  PACKAGE_ADDONS.ADDON_PRICE_LIST,
  PACKAGE_ADDONS.ADDON_REVIEW,
  PACKAGE_ADDONS.ADDON_ARTICLE,
  PACKAGE_ADDONS.ADDON_CONTACT_US,
  PACKAGE_ADDONS.ADDON_PROMOTIONS,
  PACKAGE_ADDONS.ADDON_NEWS,
  PACKAGE_ADDONS.ADDON_WEB_MANAGE,
  PACKAGE_ADDONS.ADDON_APPROVELIST,
  PACKAGE_ADDONS.ADDON_FOLLOWUP,
  PACKAGE_ADDONS.ADDON_INSTALLMENT
  // PACKAGE_ADDONS.ADDON_LAB,
  // PACKAGE_ADDONS.ADDON_LAB_MANAGEMENT,
  // PACKAGE_ADDONS.ADDON_LAB_LIST,
  // PACKAGE_ADDONS.ADDON_LAB_TYPE,
  // PACKAGE_ADDONS.ADDON_LAB_GROUP,
  // PACKAGE_ADDONS.ADDON_LAB_COMPANY,
  // PACKAGE_ADDONS.ADDON_X_RAY,
  // PACKAGE_ADDONS.ADDON_XRAY_FILM_TYPE,
]

export const PACKAGE_DENTAL_V1 = {
  STANDARD: STANDARD,
  PREMIUM: PREMIUM,
  ULTRA: ULTRA
}
